import axios from "../../axios/axios";
import { Skupina } from "../../ts/CSSkupiny";

import { APIRoutes } from "../server-api/routes";

export interface ICSSkupinyModel {
  getAllCSSkupiny(): Promise<Skupina[]>;
}

export const csSkupinyModel: ICSSkupinyModel = {
  getAllCSSkupiny: async () => {
    const res = await axios.get<Skupina[]>(APIRoutes.CSSkupina.GetAll);

    return res.data;
  },
};
